<template>
    <Container v-if="isLoading" center>
        <v-progress-circular
            indeterminate
            color="primary"
        />
    </Container>
    <router-view v-else/>
</template>

<script>
    import Container from '@/components/Vuetify/Container'

    export default {
        name: 'HomeTabScreen',

        components: {
            Container,
        },

        data: () => ({
            isLoading: true,
        }),

        mounted() {
            this.loadData()
        },

        methods: {
            async loadData() {
                try {
                    await Promise.all([
                        this.$store.dispatch('client/fetch'),
                        this.$store.dispatch('car/fetch'),
                        this.$store.dispatch('carMark/fetch'),
                        this.$store.dispatch('carModel/fetch'),
                        this.$store.dispatch('repair/fetch'),
                        this.$store.dispatch('station/fetch'),
                        this.$store.dispatch('feedback/fetch'),
                    ])
                } catch (error) {
                    await this.$root.pushNotification({
                        text: error.message,
                        color: 'error',
                    })
                }

                this.isLoading = false
            },
        },
    }
</script>
